import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ContentLoaderModule } from '@ngneat/content-loader';

import { SharedUiMaterialModule } from '@digital-platform/shared/ui-material';
import { ActionsComponent } from './actions/actions.component';
import { ActionsButtonComponent } from './actions-button/actions-button.component';
import { AddressComponent } from './address/address.component';
import { AddressPipe } from './address/address.pipe';
import { AddressInputComponent } from './address-input/address-input.component';
import { ButtonComponent } from './button/button.component';
import { CustomerSelectComponent } from './customer-select/customer-select.component';
import { FourDigitDecimaNumberDirective } from './decimal-limit/decimal-limit.directive';
import { DivisionChipSelectComponent } from './division-chip-select/division-chip-select.component';
import { EnumPipe } from './enum/enum.pipe';
import { ErrorsComponent } from './errors/errors.component';
import { FeatureFlagDirective } from './feature-flag/feature-flag.directive';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FormLoaderComponent } from './form-loader/form-loader.component';
import { MessageBarComponent } from './message-bar/message-bar.component';
import { MultiSelectLoaderComponent } from './multi-select-loader/multi-select-loader.component';
import { NestedFormComponent } from './nested-form/nested-form.component';
import { PhoneDirective } from './phone-format/phone.directive';
import { PlaceholderComponent } from './placeholder/placeholder.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { SelectLoaderComponent } from './select-loader/select-loader.component';
import { SortIconComponent } from './sort-icon/sort-icon.component';
import { StateSelectComponent } from './state-select/state-select.component';
import { StatesChipSelectComponent } from './states-chip-select/states-chip-select.component';
import { TableLoaderComponent } from './table-loader/table-loader.component';
import { TileButtonComponent } from './tile-button/tile-button.component';
import { WizardNavigationComponent } from './wizard-navigation/wizard-navigation.component';
import { WizardTocComponent } from './wizard-toc/wizard-toc.component';
import { WizardTocItemComponent } from './wizard-toc-item/wizard-toc-item.component';
import { ZipDirective } from './zip-format/zip.directive';

@NgModule({
  imports: [
    CommonModule,
    ContentLoaderModule,
    ReactiveFormsModule,
    SharedUiMaterialModule,
    MatIconModule,
    RouterModule.forChild([
      {
        path: 'placeholder',
        component: PlaceholderComponent,
      },
    ]),
  ],
  declarations: [
    ButtonComponent,
    SortIconComponent,
    TileButtonComponent,
    PlaceholderComponent,
    ActionsComponent,
    MessageBarComponent,
    ProgressBarComponent,
    WizardNavigationComponent,
    AddressComponent,
    AddressPipe,
    FileUploadComponent,
    WizardTocComponent,
    WizardTocItemComponent,
    TableLoaderComponent,
    NestedFormComponent,
    PhoneDirective,
    ActionsButtonComponent,
    FourDigitDecimaNumberDirective,
    FormLoaderComponent,
    ErrorsComponent,
    ZipDirective,
    StateSelectComponent,
    CustomerSelectComponent,
    FeatureFlagDirective,
    StatesChipSelectComponent,
    EnumPipe,
    SelectLoaderComponent,
    MultiSelectLoaderComponent,
    AddressInputComponent,
    DivisionChipSelectComponent,
  ],
  exports: [
    ButtonComponent,
    SortIconComponent,
    TileButtonComponent,
    PlaceholderComponent,
    ActionsComponent,
    MessageBarComponent,
    ProgressBarComponent,
    WizardNavigationComponent,
    AddressComponent,
    AddressPipe,
    FileUploadComponent,
    WizardTocComponent,
    WizardTocItemComponent,
    TableLoaderComponent,
    PhoneDirective,
    ActionsButtonComponent,
    FourDigitDecimaNumberDirective,
    FormLoaderComponent,
    ErrorsComponent,
    ZipDirective,
    StateSelectComponent,
    CustomerSelectComponent,
    FeatureFlagDirective,
    StatesChipSelectComponent,
    DivisionChipSelectComponent,
    EnumPipe,
    SelectLoaderComponent,
    MultiSelectLoaderComponent,
    AddressInputComponent,
  ],
})
export class SharedUiModule {}
